<ng-container *ngIf="loading == false && data && data.length != 0; else elseBlockDetails">
    <div class="al-grid grid-2">
        <!-- Left Side -->
        <div>
            <h2 class="g-card-title" style="font-size: 22px">{{ data.borrName }}</h2>
            <p class="g-text-content">
                {{ data.loanAmount | currency : 'USD' : 'symbol' : '1.0-0' }}
                <span style="padding-left: 20px">Loan #{{ data.loanNumber }}</span>
            </p>
            <p class="g-text-content">
                {{ data.purpose }}
                <span style="padding-left: 20px">
                    {{ data.product }}
                </span>
            </p>
            <p class="g-text-content">
                {{ data.branch }}
                <span style="padding-left: 20px">
                    {{ data.channel }}
                </span>
            </p>
        </div>

        <!-- Right Side -->
        <div>
            <div
                class="activity-content-header-icon"
                [ngClass]="{
                    'active-status-icon': isActiveStatus(),
                    'inactive-status-icon': !isActiveStatus()
                }"
            >
                <span class="text">{{ data.lastMilestoneStatus }}</span>
            </div>

            <p
                class="g-text-content"
                *ngIf="data.estClosingDate; else estClosingElse"
                kendoTooltip
                title="{{ ESTIMATED_CLOSE_TOOLTIP }}"
            >
                Est. Close: {{ data.estClosingDate | date : 'MM/dd/yyyy' : 'UTC' }}

                <span class="g-text-secondary" *ngIf="data.daysToEstClosing">
                    &nbsp; {{ data.daysToEstClosing }}

                    <span *ngIf="data.daysToEstClosing == 1">Day</span>
                    <span *ngIf="data.daysToEstClosing != 1">Days</span>
                </span>

                <span *ngIf="data.ptF90">
                    &nbsp;
                    <propensity-band
                        [PTFScore]="data.ptF90"
                        [showDesc]="true"
                        class="propensity-band"
                    >
                    </propensity-band>
                </span>
            </p>

            <ng-template #estClosingElse>
                <p class="g-text-content" *ngIf="data.ptF90">
                    <propensity-band
                        [PTFScore]="data.ptF90"
                        [showDesc]="true"
                        class="propensity-band"
                    >
                    </propensity-band>
                </p>
            </ng-template>

            <p
                class="g-text-content"
                *ngIf="data.predictedCloseDate != null"
                kendoTooltip
                title="{{ PREDICTED_CLOSE_TOOLTIP }}"
            >
                Predicted Close: {{ data.predictedCloseDate | date : 'MM/dd/yyyy' : 'UTC' }}
            </p>

            <p class="g-text-content" *ngIf="data.loanOwner">Owner: {{ data.loanOwner }}</p>
            <p class="g-text-content" *ngIf="data.expiration">
                Lock Expiration: {{ data.expiration | date : 'MM/dd/yyyy' : 'UTC' }}
            </p>

            <div class="flex-wrapper" *ngIf="data.predictedCloseDate != null">
                <div class="niq-icon">
                    Powered by
                    <img src="src/assets/images/niq.svg" alt="nIQ" class="niq-icon" />
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #elseBlockDetails>
    <div *ngIf="loading; else notLoadingNoData">
        <div style="margin-top: 65px">
            <spin-loader></spin-loader>
        </div>
    </div>

    <ng-template #notLoadingNoData>
        <no-data-screen [noDataType]="noDataSelection"></no-data-screen>
    </ng-template>
</ng-template>
